import React from 'react';
import { Control, Fieldset } from 'react-redux-form';
import MaskedInput from 'react-text-mask';
import InputField from './Controls/Field';
import { validatePhone } from './Validators';

const fields = [
  {
    model: '.dayTelephone',
    RRFComp: Control,
    control: {
      component: MaskedInput,
      parser: val => (val && val.replace(/\s|\(|\)|-/g, '')),
      mask: [' ', '(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
      guide: false,
      maxLength: 15,
      style: {
        width: '100%',
        border: 'none',
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        borderBottomColor: '#706e6e',
      },
      placeholder: 'Daytime Telephone',
      errors: {
        required: val => !val || !val.length,
        isPhone: val => val && !validatePhone(val),
      },
    },
    error: {
      messages: {
        required: 'Please provide a Daytime Telephone Number.',
        isPhone: val => `${val} is not a valid Telephone Number.`,
      },
    },
  },
  {
    model: '.eveningTelephone',
    RRFComp: Control,
    control: {
      component: MaskedInput,
      parser: val => (val && val.replace(/\s|\(|\)|-/g, '')),
      mask: [' ', '(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
      guide: false,
      maxLength: 15,
      style: {
        width: '100%',
        border: 'none',
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        borderBottomColor: '#706e6e',
      },
      placeholder: 'Evening Telephone',
      errors: {
        required: val => !val || !val.length,
        isPhone: val => val && !validatePhone(val),
      },
    },
    error: {
      messages: {
        required: 'Please provide an Evening Telephone Number.',
        isPhone: val => `${val} is not a valid Telephone Number.`,
      },
    },
  },
];

const Contact = ({ contactPath }) => (
  <Fieldset model={contactPath}>
    {fields.map(field => (
      <InputField key={field.model} fieldProps={field} />))}
  </Fieldset>
);

export default Contact;




// WEBPACK FOOTER //
// ./src/components/Forms/Contact.js